export let dataProps = {
    id: 0,
    store_id: null,
    section_name: '',
    news_title: '',
    news_sub_title: '',
    news_preview: '',
    news_detail: '',
    image: '',
    active: true
}


// WEBPACK FOOTER //
// ./src/store/modules/news/properties.js